import { LendingMap } from '../LendingMap';
import { Figure } from '../Figure';
import { Chart } from '../Chart';
import { StatBlock } from '../StatBlock';
import { Section } from '../Section';
import { PolicyPapers } from '../PolicyPapers';
import { PeopleGrid } from '../PeopleGrid';
import { ManagementTeam } from '../ManagementTeam';
import { CalloutBox } from '../CalloutBox';
import { SectionLink } from '../SectionLink';
import { TabGroup } from '../TabGroup';
import { Columns } from '../Columns';
import { StatGrid } from '../StatGrid';
import { Accordion } from '../Accordion';
import { BudgetTable } from '../BudgetTable';

export const sectionDictionary = {
  lendingMap: LendingMap,
  figure: Figure,
  section: Section,
  chart: Chart,
  statBlock: StatBlock,
  policyPaperBlock: PolicyPapers,
  peopleBlock: PeopleGrid,
  managementTeamBlock: ManagementTeam,
  calloutBox: CalloutBox,
  sectionLink: SectionLink,
  tabGroup: TabGroup,
  columnGroup: Columns,
  statGrid: StatGrid,
  accordion: Accordion,
  budgetTable: BudgetTable,
};
